/**
 * "news-view-1" listing variation — the compact dated link list used on the
 * archives news/landing areas. Volto-19 port of the legacy ListingNewsVariation,
 * de-branded and brand-styled.
 */
import React from 'react';
import { UniversalLink } from '@plone/volto/components';
import { flattenToAppURL } from '@plone/volto/helpers';
import './NewsListing.less';

const fmtDate = (s) => {
  if (!s) return '';
  const d = new Date(s);
  return Number.isNaN(d.getTime())
    ? ''
    : d.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: '2-digit' });
};

const NewsListingView = ({ items = [] }) => (
  <div className="pp-news-list">
    {items.map((item, i) => (
      <div className="pp-news-item" key={item['@id'] || i}>
        <UniversalLink href={flattenToAppURL(item['@id'] || '')}>
          {item.title || item.Title}
        </UniversalLink>
        <span className="pp-news-date">
          {/* issue_date first: `effective` is Plone bookkeeping and is set on
              essentially every object, so listing it first meant issue_date was
              never reached. Same defect the homepage had. */}
          {fmtDate(item.issue_date || item.effective || item.CreationDate)}
        </span>
      </div>
    ))}
  </div>
);

export default NewsListingView;
